// React
import { ComponentProps, ReactElement, ReactNode } from "react"

// UI
import { NavLink } from "@/components/navigation/NavLink"

/**
 * NavItem
 * @param param0
 * @returns
 */
export function NavItem({
	href,
	icon,
	name,
	children,
}: {
	href?: string
	icon: (props: ComponentProps<"svg">) => ReactElement<any>
	name: string
	children?: ReactNode
}) {
	return (
		<div>
			<NavLink href={href} icon={icon} name={name}>
				{children}
			</NavLink>
			<div>
				{children ? (
					<div className="w-full overflow-hidden pl-10">
						<div className="py-1">{children}</div>
					</div>
				) : null}
			</div>
		</div>
	)
}
